export default function () {
    return {};
}
